import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import ProductsLink from './common/ProductsLink'
import Product from './common/Product'
import useProduct from '../../Hook/useProduct'

function Products() {
    const { products, loading, getAllProducts } = useProduct()

    useEffect(() => {
        getAllProducts(4)
    }, [])
    return (
        <Box sx={{ width: '100%', my: 1 }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
                <Typography variant='h4' component={'div'} sx={{ my: 1 }}>Our Products</Typography>
                <Box sx={{ width: '50%', mb: 1 }}>
                    {/* <Typography variant="body1">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem officiis cumque illum, nihil consectetur eos quo consequatur molestiae aliquam et?</Typography> */}
                </Box>
            </Box>

            {/* <ProductsLink /> */}

            <Grid container spacing={2} sx={{ px: 5, mt: 2 }}>
                {products?.map((item, ind) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={ind} >
                            <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                                <Product item={item} />
                            </Box>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    )
}

export default Products